exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  width: 40px;\n}\n\nbutton {\n  padding: 0px;\n  background: none;\n  border: none;\n  margin-top: 14px;\n  margin-bottom: 16px;\n  margin-right: 4px;\n  margin-left: 4px;\n}\n\nli {\n  width: 100%;\n  padding: 0px;\n  background: none;\n}\n\nul {\n  list-style-type: none;\n  padding: 0px;\n}\n\n@media screen and (max-width: 580px) {\n  img {\n    width: 20px;\n  }\n\n  button {\n    padding: 0px;\n    background: none;\n    border: none;\n    margin-top: 4px;\n    margin-bottom: 14px;\n    margin-right: 4px;\n    margin-left: 4px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  img {\n    width: 13px;\n  }\n\n  button {\n    padding: 0px;\n    background: none;\n    border: none;\n    margin-top: 4px;\n    margin-bottom: 14px;\n    margin-right: 1px;\n    margin-left: 1px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/edit-sound/edit-sound.component.css
// module id = ../../../../../src/app/edit-sound/edit-sound.component.css
// module chunks = main